var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.011,
    height: 49.587,
    viewBox: "0 0 67.011 49.587",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "tick",
    d: "M101.594,69.65,67.4,103.843a7.7,7.7,0,0,1-10.885,0L39.089,86.416A7.7,7.7,0,1,1,49.974,75.531L61.958,87.515,90.708,58.764A7.7,7.7,0,0,1,101.594,69.65Z",
    transform: "translate(-36.834 -56.51)",
    fill: "#1280e1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.246a8e34f85eb275c07f6e6dff5652ae.svg";
export { ForwardRef as ReactComponent };